import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { ClienteCotacoesPerdidas, FiltroCotacoesPerdidas, TabelaCotacaoPerdida } from "app/types/CotacoesPerdidas";
import { IColuna } from "app/types/IColuna";
import globalMU from "globalMU";
import * as R from 'ramda';
import React from "react";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { AcoesHeadCotacoesPerdidas } from "./TableHead/AcoesHeadCotacoesPerdidas";
import { HeadersCotacoesPerdidas } from "./TableHead/HeadersCotacoesPerdidas";
import { ProdutoFiltrado } from "app/types/IProduto";

const estiloCotacoesPerdidas = require("./cotacoes-perdidas.module.scss").default;
const estiloBotoes = require('../../estilos/botoes.module.scss').default
const estilosTabela = require('../../estilos/tabelas.module.scss').default
import { fonteGradeEmPxOuPadrao } from 'app/utils/tamanhoFonteGrid'

export type CotacoesPerdidasProps = {
  foraOrcamento?: boolean
  pesquisarApenasCotacaoPerdida: boolean
  produtos: ProdutoFiltrado[];
  cotacoes: PagedMessageResponse<TabelaCotacaoPerdida>;
  apenasCotacoesPerdidas: boolean;
  clienteSelecionado: ClienteCotacoesPerdidas;
  tamanhoFontePadrao: number;
  permiteEngrenagemGrid:boolean
  mostrarNomeComoCodigo: boolean
  colunas: IColuna[]
  onPesquisar: (filtroCotacoesPerdidas: FiltroCotacoesPerdidas, apenasCotacao: boolean) => void;
  onPesquisarCliente: () => void;
  onPesquisarProduto: () => void;
  onExcluirCliente: () => void;
  onAlterarFonte: (tamanho: number) => void;
  onRemoveItem: (produto: ProdutoFiltrado) => void
  onAlterarApenasCotacoesPerdidas: (apenasCotacoesPerdidas: boolean) => void
  onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
  onToggleSelecionarTodasColunas: (selecionar: boolean) => void
  onPesquisarComPaginacao: (filtroCotacoesPerdidas: FiltroCotacoesPerdidas, apenasCotacao: boolean) => void
};


export const CotacoesPerdidas = (props: CotacoesPerdidasProps) => {

  const itemTabelaCotacoesPerdidas = ({ nomeColuna, dadosTabela }: { nomeColuna: string, dadosTabela: TabelaCotacaoPerdida }) => {

    const fn = R.cond([
      [R.equals("Filial"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.CodigoFilial}</div>],
      [R.equals("Data"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{globalMU.formatDateTime(dadosTabela.DataMovimentacao)}</div>],
      [R.equals("Quantidade"), _ => <div className={`_table-cell _text-right ${estiloCotacoesPerdidas.tableCellBody}`}>{globalMU.formatarValorNumerico(dadosTabela.Quantidade, 3, false)}</div>],
      [R.equals("Código"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.CodigoProdutoExibicao}</div>],
      [R.equals("Produto"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.DescricaoProdutoExibicao}</div>],
      [R.equals("PrecoVenda"), _ => <div className={`_table-cell _text-right ${estiloCotacoesPerdidas.tableCellBody}`}>{globalMU.formatarValorNumerico(dadosTabela.PrecoVenda, 3, true)}</div>],
      [R.equals("PrecoConcorrente"), _ => <div className={`_table-cell _text-right ${estiloCotacoesPerdidas.tableCellBody}`}>{globalMU.formatarValorNumerico(dadosTabela.PrecoConcorrente, 3, true)}</div>],
      [R.equals("Concorrente"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.NomeConcorrente}</div>],
      [R.equals("Cliente"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.NomeCliente}</div>],
      [R.equals("Vendedor"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.NomeVendedor}</div>],
      [R.equals("Motivo"), _ => <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>{dadosTabela.DescricaoMotivo}</div>],
    ])

    return fn(nomeColuna)
  }

  const onObterDadosFormulario = (numeroPagina?: number) => {
    return ({
      CodigosProdutos: props.produtos?.length > 0 ? props.produtos?.map((value) => value.Codigo) : [],
      CodigoCliente: props.clienteSelecionado != null ? props.clienteSelecionado.Codigo : null,
      NumeroPagina: numeroPagina ?? 1,
      TamanhoPagina: 20
    })
  }

  const tabelaCotacoesPerdidas = <div className={estilosTabela.containerRolavel}
                style={{ marginTop: "20px", marginRight: "10px" }}
            >

    <AcoesHeadCotacoesPerdidas
      onToggleColunaSelecionada={props.onToggleColunaSelecionada}
      onAlterarFonte={props.onAlterarFonte}
      permiteEngrenagemGrid={props.permiteEngrenagemGrid}
      tamanhoFonte={props.tamanhoFontePadrao}
      colunas={props.colunas}
      mostrarNomeComoCodigo={props.mostrarNomeComoCodigo}
      onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
    />

    <div style={{ fontSize: fonteGradeEmPxOuPadrao(props.tamanhoFontePadrao) }} className="_overflow-x-auto">
      <div className={`_table _w-full _border-collapse ${estiloCotacoesPerdidas.tabelaCotacoesPerdidas} `}>

        <HeadersCotacoesPerdidas colunas={props.colunas} mostrarNomeComoCodigo={props.mostrarNomeComoCodigo} />

        <div className="_table-row-group">
          {props.cotacoes?.Entities?.map((value, index) => (
            <div className={`_table-row ${estiloCotacoesPerdidas.linha}`} key={index} >
              {props.colunas.filter(c => c.Selecionada).map(coluna => {
                const celula = itemTabelaCotacoesPerdidas({
                  nomeColuna: coluna.Nome,
                  dadosTabela: value
                })
                return React.isValidElement(celula)
                  ? React.cloneElement(celula as React.ReactElement<any>, { key: coluna.Nome })
                  : null
              })}
            </div>
          ))}
        </div>

      </div>
    </div>
  </div>

  const botaoPesquisar = <div className="_mt-7 _mb-2">
    <button
      id="CotacoesPerdidas_BotaoPesquisar"
      className={`no-global-button ${estiloBotoes.botaoPrimario}`}
      onClick={() => props.onPesquisar(onObterDadosFormulario(), props.apenasCotacoesPerdidas)}
    >
      Pesquisar
    </button>
  </div>

  const formulario = () => {

    const checkboxApenasCotacaoPerdida = <>
      {!props.foraOrcamento && !props.pesquisarApenasCotacaoPerdida &&  
        <div>
          <input
            name="apenasCotacoesPerdidas"
            id="pesquisarCotacoesPerdidas_ApenasCotacaoPerdidaOrcamento"
            type="checkbox"
            checked={props.apenasCotacoesPerdidas}
            onChange={() =>
              props.onAlterarApenasCotacoesPerdidas(
                !props.apenasCotacoesPerdidas
              )}
            className="!_ml-[160px]"
          />
          <label className="_pl-1 _cursor-pointer _inline-block _text-left _font-normal" 
            htmlFor="pesquisarCotacoesPerdidas_ApenasCotacaoPerdidaOrcamento" 
          >Apenas Cotação Perdida do Orçamento</label>
        </div>
      } 
    </>

    const inputCliente = (props.pesquisarApenasCotacaoPerdida || !props.apenasCotacoesPerdidas) && (
      <div className="_flex _mb-1">
        <label className="_w-[160px] _text-right _font-normal _pr-[10px]">Cliente</label>
        <input
          id="pesquisarCotacoesPerdidas_CampoCliente"
          className="_w-[280px] _p-1"
          name="cliente"
          type="text"
          readOnly
          disabled // sempre fica desabilitad
          title="Clique na lupa para pesquisar o cliente"
          placeholder="Clique na lupa para pesquisar"
          value={props.clienteSelecionado?.Nome != null ? props.clienteSelecionado?.Nome : ""}
        />
        <FontAwesomeIcon
          className="_text-2xl _mx-1"
          id="pesquisarCotacoesPerdidas_BotaoPesquisarCliente"
          color={"#3c8ac9"}
          icon={faSearch}
          cursor="pointer"
          onClick={() => props.onPesquisarCliente()}
        />
        <FontAwesomeIcon
          className="_text-2xl"
          id="pesquisarCotacoesPerdidas_BotaoExcluirCliente"
          color={"#f25713"}
          icon={faTimesCircle}
          cursor="pointer"
          onClick={() => props.onExcluirCliente()}
        />
      </div>
    )

    const inputProdutos = <div className="_flex _mb-1"> 
      <label className="_w-[160px] _text-right _font-normal _pr-[10px]">Produtos</label>
      <FontAwesomeIcon
        className="_text-2xl _mx-1"
        color={"#3c8ac9"}
        id="pesquisarCotacoesPerdidas_BotaoPesquisarProduto"
        icon={faSearch}
        cursor="pointer"
        onClick={() => props.onPesquisarProduto()}
      />
    </div>

    return <div className="_pt-8">
      {checkboxApenasCotacaoPerdida}
      {inputCliente}
      {inputProdutos}
    </div>
  }

  const produtosFiltrados = () => {
    const tableHead = <div className="_table-header-group"
      id="CotacoesPerdidas_tabelaProdutosSelecionados"
    >
      <div className="_table-row">
        <div className={`_table-cell _font-bold ${estiloCotacoesPerdidas.tableCellHeader}`}>
          {props.mostrarNomeComoCodigo ? "Código" : "Referência"}
        </div>
        <div
          id="CotacoesPerdidas_campoDescricao"
          className={`_table-cell _font-bold _w-10/12  ${estiloCotacoesPerdidas.tableCellHeader}`}>
          Descrição
        </div>
        <div
          id="CotacoesPerdidas_campoExcluir"
          className={`_table-cell _font-bold _text-center ${estiloCotacoesPerdidas.tableCellHeader}`}>
          Excluir
        </div>
      </div>
    </div>

    const tableRow = <div className="_table-row-group"
      id="CotacoesPerdidas_tabelaProdutosSelecionados_linhas"
    >
      {props.produtos?.map((produto) => (
        <div key={produto.CodigoProduto} 
            className={`_table-row  ${estiloCotacoesPerdidas.linha}`}
            id={`CotacoesPerdidas_tabelaProdutosSelecionados_linha_${produto.CodigoProduto}`}
        >
          <div className={`_table-cell  ${estiloCotacoesPerdidas.tableCellBody}`}>
            {produto.CodigoProduto.toUpperCase()}
          </div>
          <div className={`_table-cell  ${estiloCotacoesPerdidas.tableCellBody}`}>
            {produto.Descricao}
          </div>
          <div className={`_table-cell _text-center ${estiloCotacoesPerdidas.tableCellBody}`}>
            <FontAwesomeIcon
              className="_text-2xl"
              icon={faTimesCircle}
              color={"#f25713"}
              cursor="pointer"
              onClick={() => props.onRemoveItem(produto)}
            />
          </div>
        </div>
      ))}
    </div>

    return <div className={`_table _w-full _border- _mb-8 ${estiloCotacoesPerdidas.tabelaCotacoesPerdidas}`}
      id="CotacoesPerdidas_tabelaProdutosSelecionados"
    >
      {tableHead}
      {tableRow}
    </div>
  }

  return (
    <>

      {formulario()}

      {props.produtos?.length > 0 &&
        produtosFiltrados()
      }

      {botaoPesquisar}

      {props.cotacoes?.Entities?.length > 0 && tabelaCotacoesPerdidas}

      {props.cotacoes?.PageCount > 1 && (
        <div className="_mt-4">
          <Paginacao
            paginaAtual={props.cotacoes?.ActualPage}
            totalPaginas={props.cotacoes?.PageCount}
            id="CotacoesPerdidas_Paginacao"
            onAlterarListaSelecionada={(numeroPagina) =>
              props.onPesquisarComPaginacao(onObterDadosFormulario(numeroPagina), props.apenasCotacoesPerdidas)}
          />
        </div>
      )}
      {props.cotacoes?.RowsCount > 1 && (
        <div className="_mb-12 _mt-4">{`Foram encontradas ${props.cotacoes?.RowsCount} cotações perdidas`}</div>
      )}
      {props.cotacoes?.RowsCount == 1 && (
        <div className="_mb-12 _mt-4">{`Foi encontrada ${props.cotacoes?.RowsCount} cotação perdida`}</div>
      )}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};


